// extracted by mini-css-extract-plugin
export default {"newTag":"NewTag_newTag__prTAM"};